// extracted by mini-css-extract-plugin
export var column = "_th-0";
export var divider = "_th-2";
export var timePicker = "_th-1";